class DateHelper {
    static inputFormat(dateObj) {
        let dd = dateObj.getDate();
        if (dd < 10) dd = '0' + dd;

        let mm = dateObj.getMonth() + 1;
        if (mm < 10) mm = '0' + mm;

        let yy = dateObj.getFullYear();

        return yy + '-' + mm + '-' + dd;
    }

    static gapFormat(startDate, endDate) {
        return {
            startDate: this.inputFormat(startDate),
            endDate: this.inputFormat(endDate)
        };
    }

    static getDate(daysDiff = 0, monthsDiff = 0, yearsDiff = 0) {
        let currentDate = new Date();

        let neededYear = currentDate.getFullYear() - yearsDiff;
        let neededMonth = currentDate.getMonth() - monthsDiff;
        let neededDate = currentDate.getDate() - daysDiff;

        return new Date(neededYear, neededMonth, neededDate);
    }

    static getDaysInMonth(dateObj) {
        let currentYear = dateObj.getFullYear();
        let currentMonth = dateObj.getMonth() + 1;
        let currentDate = 0;

        let expectedDate = new Date(currentYear, currentMonth, currentDate);

        return expectedDate.getDate();
    }

    static getFirstDateOfMonth(dateObj) {
        let currentDate = dateObj.getDate();
        let expectedDate = currentDate - (currentDate - 1);

        dateObj.setDate(expectedDate);

        return new Date(dateObj);
    }

    static getLastDateOfMonth(dateObj) {
        let startDate = this.getFirstDateOfMonth(dateObj).getDate();
        let monthDays = this.getDaysInMonth(dateObj) - 1;

        dateObj.setDate(startDate + monthDays);

        return new Date(dateObj);
    }

    static getMonthGap(dateObj) {
        let firstDate = this.getFirstDateOfMonth(dateObj);
        let lastDate = this.getLastDateOfMonth(dateObj);

        return this.gapFormat(firstDate, lastDate);
    }

    static getFirstDateOfWeek(dateObj) {
        let currentDate = dateObj.getDate();

        let currentDay = dateObj.getDay() - 1;
        if (currentDay === -1) {
            currentDay = 6;
        }

        let expectedDate = currentDate - currentDay;
        dateObj.setDate(expectedDate);

        return new Date(dateObj);
    }

    static getLastDateOfWeek(dateObj) {
        let firstDate = this.getFirstDateOfWeek(dateObj).getDate();

        dateObj.setDate(firstDate + 6);

        return new Date(dateObj);
    }

    static getWeekGap(dateObj) {
        let startDate = this.getFirstDateOfWeek(dateObj);
        let lastDate = this.getLastDateOfWeek(dateObj);

        return this.gapFormat(startDate, lastDate);
    }

    static getFirstDateOfYear(dateObj) {
        const year = dateObj.getFullYear();

        return new Date(year, 0, 1);
    }

    static getLastDateOfYear(dateObj) {
        const year = dateObj.getFullYear();

        return new Date(year + 1, 0, 0);
    }

    static getYearGap(dateObj) {
        const startDate = this.getFirstDateOfYear(dateObj);
        const endDate = this.getLastDateOfYear(dateObj);

        return this.gapFormat(startDate, endDate);
    }

    static getDatesGap(dateObj) {
        return this.gapFormat(dateObj, new Date());
    }

    static getToday() {
        const todayDate = this.getDate();

        return this.gapFormat(todayDate, todayDate);
    }

    static getYesterday() {
        const yesterdayDate = this.getDate(1);

        return this.gapFormat(yesterdayDate, yesterdayDate);
    }

    static getDayBeforeYesterday() {
        const dayBeforeYesterdayDate = this.getDate(2);

        return this.gapFormat(dayBeforeYesterdayDate, dayBeforeYesterdayDate);
    }

    static getLastThreeDays() {
        const date = this.getDate(2);

        return this.getDatesGap(date);
    }

    static getLastSevenDays() {
        const date = this.getDate(6);

        return this.getDatesGap(date);
    }

    static getLastNineDays() {
        const date = this.getDate(8);

        return this.getDatesGap(date);
    }

    static getCurrentWeek() {
        return this.getWeekGap(new Date());
    }

    static getPreviousWeek() {
        const previousWeekDate = this.getDate(7);

        return this.getWeekGap(previousWeekDate);
    }

    static getLastThirtyDays() {
        const neededDays = this.getDate(30);

        return this.getDatesGap(neededDays);
    }

    static getPreviousThirtyDays() {
        const neededDate = this.getDate(30);

        return this.getDatesGap(neededDate);
    }

    static getCurrentMonth() {
        const currentMonthDate = this.getDate();

        return this.getMonthGap(currentMonthDate);
    }

    static getPreviousMonth() {
        const previousMonthDate = this.getDate(0, 1);

        return this.getMonthGap(previousMonthDate);
    }

    static getLastThreeMonths() {
        const currentDate = this.getDate().getDate();

        const previousMonthDate = this.getDate(0, 1);
        const previousMonthDaysCount = this.getDaysInMonth(previousMonthDate);

        const beforePreviousMonthDate = this.getDate(0, 2);
        const beforePreviousMonthDaysCount = this.getDaysInMonth(beforePreviousMonthDate);

        const thirdMonthDate = this.getDate(0, 3);
        const thirdMonthDaysCount = this.getDaysInMonth(thirdMonthDate);
        const thirdMonthNeededDays = thirdMonthDaysCount - currentDate;

        const totalDays = currentDate + previousMonthDaysCount + beforePreviousMonthDaysCount + thirdMonthNeededDays;
        const neededDate = this.getDate(totalDays);

        return this.getDatesGap(neededDate);
    }

    static getLastThreeHundredSixtyFiveDays() {
        const neededDays = this.getDate(365);

        return this.getDatesGap(neededDays);
    }

    static getCurrentYear() {
        const currentYearDate = this.getDate();

        return this.getYearGap(currentYearDate);
    }

    static getPreviousYear() {
        const previousYearDate = this.getDate(0, 0, 1);

        return this.getYearGap(previousYearDate);
    }
}

export default DateHelper;
